// import React, { useEffect, useState } from "react";
// import API from "../services/api";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// function DownloadExcelPage() {
//   const [agents, setAgents] = useState([]);

//   // ✅ FILTER STATES
//   const [filterType, setFilterType] = useState("all"); // all | day | month | range
//   const [selectedDate, setSelectedDate] = useState("");
//   const [selectedMonth, setSelectedMonth] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const res = await API.get("/agents/full-report");
//       setAgents(res.data || []);
//     } catch (err) {
//       alert("❌ Failed to load data");
//     }
//   };

//   // ================= FILTER LOGIC =================
//   const getFilteredData = () => {
//     if (filterType === "all") return agents;

//     return agents.filter((a) => {
//       const date = new Date(a["Upload Time"] || a.upload_datetime);

//       if (filterType === "day" && selectedDate) {
//         const d1 = new Date(selectedDate).toDateString();
//         return date.toDateString() === d1;
//       }

//       if (filterType === "month" && selectedMonth) {
//         const [year, month] = selectedMonth.split("-");
//         return (
//           date.getFullYear() === Number(year) &&
//           date.getMonth() + 1 === Number(month)
//         );
//       }

//       if (filterType === "range" && startDate && endDate) {
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         return date >= start && date <= end;
//       }

//       return true;
//     });
//   };

//   // ================= EXPORT =================
//   const handleDownload = () => {
//     const filteredData = getFilteredData();

//     if (filteredData.length === 0) {
//       alert("No data to export");
//       return;
//     }

//     const worksheet = XLSX.utils.json_to_sheet(filteredData);

//     worksheet["!cols"] = Object.keys(filteredData[0]).map(() => ({
//       wch: 25,
//     }));

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Agents");

//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     });

//     const blob = new Blob([excelBuffer], {
//       type: "application/octet-stream",
//     });

//     saveAs(blob, "Filtered_Agents_Report.xlsx");
//   };

//   const filteredData = getFilteredData();

//   return (
//     <div className="logs-container">

//       <div className="logs-header">
//         <h1>📥 Download Agents Report</h1>
//         <p>Export filtered agent data in Excel format</p>
//       </div>

//       {/* ================= FILTER UI ================= */}
//       <div style={{ textAlign: "center", marginTop: "20px" }}>

//         <select
//           value={filterType}
//           onChange={(e) => setFilterType(e.target.value)}
//         >
//           <option value="all">All Data</option>
//           <option value="day">Day Wise</option>
//           <option value="month">Month Wise</option>
//           <option value="range">Custom Range</option>
//         </select>

//         {/* DAY */}
//         {filterType === "day" && (
//           <input
//             type="date"
//             value={selectedDate}
//             onChange={(e) => setSelectedDate(e.target.value)}
//             style={{ marginLeft: "10px" }}
//           />
//         )}

//         {/* MONTH */}
//         {filterType === "month" && (
//           <input
//             type="month"
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             style={{ marginLeft: "10px" }}
//           />
//         )}

//         {/* RANGE */}
//         {filterType === "range" && (
//           <>
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               style={{ marginLeft: "10px" }}
//             />
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               style={{ marginLeft: "10px" }}
//             />
//           </>
//         )}
//       </div>

//       {/* ================= DOWNLOAD BUTTON ================= */}
//       <div style={{ textAlign: "center", marginTop: "30px" }}>
//         <button className="approve-btn" onClick={handleDownload}>
//           📥 Download Excel
//         </button>
//       </div>

//       {/* ================= COUNT ================= */}
//       <div style={{ marginTop: "20px", textAlign: "center" }}>
//         <p>Total Records: {filteredData.length}</p>
//       </div>

//     </div>
//   );
// }

// export default DownloadExcelPage;












import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function DownloadExcelPageForAccounts() {
  const [agents, setAgents] = useState([]);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const navigate = useNavigate();

  // ✅ FILTER STATES
  const [filterType, setFilterType] = useState("all");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // 🖱️ Mouse Tracking
  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await API.get("/agents/full-report");
      // If API returns data, use it; otherwise, the state remains empty or shows sample
      setAgents(res.data || []);
    } catch (err) {
      console.error("❌ Failed to load data", err);
      // Optional: Set sample data if API fails for testing purposes
    }
  };

  // ================= FILTER LOGIC =================
  const getFilteredData = () => {
    if (filterType === "all") return agents;

    return agents.filter((a) => {
      const dateStr = a["Upload Time"] || a.upload_datetime || a.created_at;
      if (!dateStr) return false;
      const date = new Date(dateStr);

      if (filterType === "day" && selectedDate) {
        return date.toDateString() === new Date(selectedDate).toDateString();
      }

      if (filterType === "month" && selectedMonth) {
        const [year, month] = selectedMonth.split("-");
        return (
          date.getFullYear() === Number(year) &&
          date.getMonth() + 1 === Number(month)
        );
      }

      if (filterType === "range" && startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        return date >= start && date <= end;
      }

      return true;
    });
  };

// logout handle 

const handleLogout = () => {
    localStorage.removeItem("admin_id");
    localStorage.removeItem("role");
    navigate("/");
  };








  // ================= EXPORT =================
  const handleDownload = () => {
    const filteredData = getFilteredData();

    if (filteredData.length === 0) {
      alert("No data available for the selected filters.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    worksheet["!cols"] = Object.keys(filteredData[0] || {}).map(() => ({ wch: 20 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Agents_Report");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `Agent_Report_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  const filteredData = getFilteredData();

  return (
    <div className="download-page-wrapper">
      <style>{`
        .download-page-wrapper {
          min-height: 100vh;
          background: #020617;
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
          padding: 60px 20px 120px 20px;
          position: relative;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(34, 197, 94, 0.05) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }

        .container { max-width: 1000px; margin: 0 auto; position: relative; z-index: 2; }

        .header { text-align: center; margin-bottom: 40px; }
        .header h1 {
          font-size: 32px; font-weight: 800; letter-spacing: -1px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
        }

        /* --- FILTER CARD --- */
        .filter-card {
          background: rgba(255, 255, 255, 0.02);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 28px;
          padding: 40px;
          text-align: center;
          margin-bottom: 40px;
        }

        .filter-group {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 15px;
          flex-wrap: wrap;
        }

        select, input[type="date"], input[type="month"] {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 12px 20px;
          border-radius: 14px;
          color: white;
          font-size: 14px;
          outline: none;
          transition: 0.3s;
        }

        select:focus, input:focus { border-color: #22c55e; background: rgba(255,255,255,0.08); }

        /* --- DOWNLOAD BUTTON --- */
        .download-btn {
          margin-top: 30px;
          background: #22c55e;
          color: #020617;
          border: none;
          padding: 16px 40px;
          border-radius: 16px;
          font-weight: 800;
          font-size: 16px;
          cursor: pointer;
          transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          align-items: center;
          gap: 12px;
          margin-left: auto;
          margin-right: auto;
        }

        .download-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 30px rgba(34, 197, 94, 0.25);
          filter: brightness(1.1);
        }

        /* --- DATA PREVIEW --- */
        .preview-box {
          margin-top: 20px;
          background: rgba(0, 0, 0, 0.2);
          border-radius: 20px;
          padding: 20px;
          border: 1px solid rgba(255, 255, 255, 0.03);
        }

        .preview-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          color: #64748b;
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
        }

        /* --- BACK BUTTON --- */
        .logout-btn {
  position: fixed; 
  bottom: 20px; 
  left: 20px;
  /* Reduced padding for a smaller footprint */
  padding: 12px; 
   width:12rem;
  height: 45px;
  
  background: rgba(255, 255, 255, 0.05); 
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1); 
  color: #94a3b8;
  
  /* Circular or slightly rounded */
  border-radius: 12px; 
  cursor: pointer; 
  z-index: 100; 
  transition: all 0.3s ease; 
  
  display: flex; 
  align-items: center; 
  justify-content: center;
}

.logout-btn:hover { 
  background: rgba(255, 255, 255, 0.1); 
  color: white; 
  transform: translateY(-3px); /* Small lift instead of sliding right */
  border-color: rgba(255, 255, 255, 0.3);
}
      `}</style>

      <div className="spotlight"></div>

      <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <span>🚪</span> Logout
          </button>
        </div>

      <div className="container">
        <header className="header">
          <h1>📥 Download Reports</h1>
          <p>Generate and export comprehensive agent spreadsheets</p>
        </header>

        <div className="filter-card">
          <div className="filter-group">
            <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
              <option value="all">📁 All Records</option>
              <option value="day">📅 Day Wise</option>
              <option value="month">🗓️ Month Wise</option>
              <option value="range">📏 Custom Range</option>
            </select>

            {filterType === "day" && (
              <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
            )}

            {filterType === "month" && (
              <input type="month" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} />
            )}

            {filterType === "range" && (
              <>
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                <span style={{color: '#475569'}}>to</span>
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </>
            )}
          </div>

          <button className="download-btn" onClick={handleDownload}>
            📥 Download XLSX Report
          </button>

          <div className="preview-box">
            <div className="preview-header">
              <span>Ready for Export</span>
              <span>{filteredData.length} Agents Found</span>
            </div>
            
            {/* Quick Summary View */}
            <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '10px' }}>
              {filteredData.slice(0, 5).map((item, idx) => (
                <div key={idx} style={{ 
                  background: 'rgba(255,255,255,0.03)', 
                  padding: '10px 15px', 
                  borderRadius: '12px',
                  fontSize: '12px',
                  whiteSpace: 'nowrap',
                  border: '1px solid rgba(255,255,255,0.05)'
                }}>
                  <div style={{color: '#22c55e', fontWeight: 'bold'}}>{item.name_as_per_pan || item.Name}</div>
                  <div style={{color: '#64748b'}}>
  {item.Comm_Code || "Pending..."}
</div>
                </div>
              ))}
              {filteredData.length > 5 && (
                <div style={{ padding: '10px', color: '#475569', fontSize: '12px' }}>
                  + {filteredData.length - 5} more
                </div>
              )}
              {filteredData.length === 0 && (
                <div style={{ padding: '10px', color: '#475569', fontSize: '12px', width: '100%' }}>
                  No records match your current filter settings.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownloadExcelPageForAccounts;